import { defineMessages } from 'react-intl';

export default defineMessages({
    continueText: {
        id: 'ml.agent.quoteandbind.pa.disclosureToQuote.We\'ll review your quote next',
        defaultMessage: 'We\'ll {reviewYourQuote} next!'
    },
    reviewYourQuote: {
        id: 'ml.agent.quoteandbind.pa.disclosureToQuote.review your quote',
        defaultMessage: 'review your quote'
    },
    confirmPremiumNextText: {
        id: 'ml.agent.quoteandbind.pa.disclosureToQuote.We\'ll confirm your premium and payment details next',
        defaultMessage: 'We\'ll {confirmPremium} next'
    },
    confirmPremium: {
        id: 'ml.agent.quoteandbind.pa.disclosureToQuote.confirm your premium and payment details',
        defaultMessage: 'confirm your premium and payment details'
    },
    orderMVRforHIDriverAgent: {
        id: 'ml.agent.quoteandbind.pa.disclosureToQuote.Hawaii MVRs return in approximately 2-3 days. When MVR is returned, you will be able to continue to the next screen.',
        defaultMessage: 'Hawaii MVRs return in approximately 2-3 days. When MVR is returned, you will be able to continue to the next screen.'     
    },
    premiumChangedDueToInfoReceivedAgent: {
        id: 'ml.agent.quoteandbind.pa.adjustments.We have received additional information which may have adjusted your premium.',
        defaultMessage: 'We have received additional information which may have adjusted your premium.'
    },
    discloseExcludedDriverInfo: {
        id: 'ml.agent.quoteandbind.pa.discloseExcludedDriverInfo',
        defaultMessage: 'This state requires entry of incident information for all rated and excluded drivers.'
    },
    somethingWentWrong: {
        id: 'ml.agent.quoteandbind.pa.Something went wrong during this process.  Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    },
    uwIssuesThatBlockQuote: {
        id: 'ml.agent.quoteandbind.pa.uwIssuesThatBlockQuote',
        defaultMessage: 'UW Issues that block quote'
    },
    mvrOrderedError: {
        id: 'ml.agent.quoteandbind.pa.mvrOrderedError',
        defaultMessage: 'An MVR cannot be ordered without valid Driver Details'
    },
    furtherInfoMessage: {
        id: 'ml.agent.quoteandbind.pa.furtherInfoMessage',
        defaultMessage: 'For further information see'
    },
    riskAnalysis: {
        id: 'ml.agent.quoteandbind.pa.riskAnalysis',
        defaultMessage: 'Risk Analysis'
    },
});